import { newClient } from '../axios-client-factory'
import { requireNonNull } from '../../utils/coding-utils'
import { fileClientToken } from '../axios-client-file-token'


// 主播管理列表
export const getAnchorManageList = function({query, pager, sorter}) {
  return newClient().post('/guild/anchor/manage/list', {
    page: pager.page,
    size: pager.limit,
    userId: requireNonNull(query.userId),
    remark: requireNonNull(query.remark),
    contractStatus: requireNonNull(query.contractStatus),
    contractStartTime: requireNonNull(query.contractStartTime),
    contractEndTime: requireNonNull(query.contractEndTime),
    applyStartTime: requireNonNull(query.applyStartTime),
    applyEndTime: requireNonNull(query.applyEndTime),
    isProhibitLive: query.isProhibitLive
  })
}

// 导出数据
export const exportUserDate = function (model) {
  return fileClientToken().post('/guild/anchor/manage/contract/export',model)
}

// 签约记录列表
export const getAnchorContractLog = function({query, pager, sorter}) {
  return newClient().post('/guild/anchor/manage/contractLog/list', {
    page: pager.page,
    size: 10000,
    userId: requireNonNull(query.userId),
    // guildId: requireNonNull(query.guildId),
  })
}

// 查看违规记录
export const getLiveViolationLog = function({query, pager, sorter}) {
  return newClient().post('/guild/violation/log', {
    page: pager.page,
    size: pager.limit,
    id: requireNonNull(query.id),
    userId: requireNonNull(query.userId),
    operationTimeStart: requireNonNull(query.operationTimeStart),
    operationTimeEnd: requireNonNull(query.operationTimeEnd),
  })
}

export const getUserRemark = function (userId) {
  return newClient().get('/guild/user/special-desc/desc/' + userId)
}

export const addOrRemoveRemarkInfo = function (model) {
  return newClient().post('/guild/anchor/manage/addRemark', model)
}



// export const userRevenueInfo = function() {
//   return newClient().get('/guild/invite-friend/income-summary')
// }


// export const getWeChatDetail = function (model) {
//   return newClient().post('/guild/new-assistant-feedback/records', model)
// }




// export const removeSpecialDescInfo = function (model) {
//   return newClient().post('/guild/user/special-desc/del', model)

// }

export const getSpecialDescIdList = function() {
  return newClient().get('/guild/user/special-desc')
}



// WEBPACK FOOTER //
// ./src/api/approval/anchor-approval.js